import PropertyFilterPanel from 'src/components/property-filter-panel';

import { emptyFilterQuery } from '@/utils/table/types';

import { CollapsibleFilterPreview } from '../filter-preview/CollapsibleFilterPreview';
import { useGetWidgetData } from '../gigawidget/hooks/useGetWidgetData';
import type { WidgetDataSource } from '../gigawidget/types';
import type { GigawidgetSettings } from './util';

type FilterPreviewProps = {
  dataSource: WidgetDataSource;
  settings: GigawidgetSettings;
  /**
   * When the widget is compact (small in either dimension — see `widgetCompact`),
   * the pills collapse into a floating filter icon so the chart reclaims the
   * space. This both keeps the pills usable (RSP-4068) and stops the donut count
   * label from being squeezed into the chart (RSP-4069).
   */
  isCompact: boolean;
};

export const FilterPreview = ({
  dataSource,
  settings,
  isCompact,
}: FilterPreviewProps) => {
  const { tableProps, loading } = useGetWidgetData({ dataSource });

  const tokenCount = settings.filtering?.tokens?.length ?? 0;

  if (loading) {
    return null;
  }

  return (
    <CollapsibleFilterPreview tokenCount={tokenCount} isCompact={isCompact}>
      <PropertyFilterPanel
        query={settings.filtering ?? emptyFilterQuery}
        filteringProperties={tableProps.filteringProperties}
        filteringOptions={tableProps.propertyFilterProps.filteringOptions}
        onChange={() => null}
        customControl={<></>}
        customFilterActions={<></>}
        hideOperations={false}
        disabled
        virtualScroll={true}
      />
    </CollapsibleFilterPreview>
  );
};
